import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { FuldmagtInfo } from 'src/app/api/models';
import { UserService } from 'src/app/api/services';
import { AppConfig } from 'src/app/config/app-config';
import { AppConfigService } from 'src/app/config/app-config.service';
import { ComponentCanDeactivateDirective } from 'src/app/core/components/component-can-deactivate';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { FuldmagtChoiceService } from 'src/app/projekter/fuldmagt-choice.service';

@Component({
  selector: 'bom-skift-bruger',
  templateUrl: './skift-bruger.component.html',
  styleUrls: ['./skift-bruger.component.scss'],
})
export class SkiftBrugerComponent extends ComponentCanDeactivateDirective implements OnInit {
  isLoading = true;
  fuldmagtGivere: FuldmagtInfo[];
  returnUrl: string;
  trapping$ = new BehaviorSubject<boolean>(true);
  openDialog$ = new BehaviorSubject<boolean>(false);
  pendingFileUrl: string;

  private appConfig: AppConfig;

  constructor(
    private userService: UserService,
    private fuldmagtChoiceService: FuldmagtChoiceService,
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private appConfigService: AppConfigService
  ) {
    super();
  }

  ngOnInit() {
    this.appConfig = this.appConfigService.getConfig();

    this.route.queryParams.subscribe(queryParams => {
      this.returnUrl = queryParams['returnUrl'];
    });

    this.userService.getFuldmagter().subscribe(fuldmagtGivere => {
      this.isLoading = false;
      this.fuldmagtGivere = fuldmagtGivere;
    });
  }

  continueAsUser(fuldmagtUser: FuldmagtInfo) {
    this.fuldmagtChoiceService.set(fuldmagtUser ? fuldmagtUser.encryptedCPR : 'self');

    if (!!this.authService.user) {
      this.authService.getUserInfo().subscribe(userInfo => {
        this.authService.userInfo$.next(userInfo);
        this.redirectAfterUserChoice();
      });
    }
  }

  redirectAfterUserChoice() {
    if (this.returnUrl) {
      // Allow redirects to DokumentWeb
      if (this.returnUrl.startsWith(this.appConfig.dokumentWebUrl)) {
        this.pendingFileUrl = this.returnUrl;
        window.location.href = this.returnUrl;
        this.returnUrl = null;
        return;
      }
      this.router.navigateByUrl(this.returnUrl).then(() => {
        // returnUrl may contain another returnUrl.
        // If this is the case, continue doing redirects recursively
        // until we reach the final destination
        if (this.returnUrl.split('?')[0] !== window.location.pathname) {
          this.redirectAfterUserChoice();
        } else {
          this.returnUrl = null;
        }
      });
    } else {
      this.router.navigate(['/']);
    }
  }

  canDeactivate(): boolean | import('rxjs').Observable<boolean> {
    const fuldmagtChoice = this.fuldmagtChoiceService.getChoice();
    if (!fuldmagtChoice) {
      this.openDialog$.next(true);
    }
    return !!fuldmagtChoice;
  }

  warnOnUnload(): boolean {
    return false;
  }

  closeDialog(): void {
    this.openDialog$.next(false);
  }
}
